
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/substabelecido",
      function () {
        return require("private-next-pages/substabelecido.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/substabelecido"])
      });
    }
  